import Left from "./left";
import Right from "./right";
import Top from "./top";
import Bottom from "./bottom";
import { useState } from "react";
import { Route, Routes } from "react-router-dom";
import Searchh from "./search";
//deleted
import Continent from "./continent";
import Error from "./error";

//deleted
export default function Main() {
  const [ss, setss] = useState([]);
  const [q, setq] = useState(true);
  const [continent, setcontinent] = useState("all");
  const[countrysearch,setcountrysearch ]=useState("")

  return (
    <div>
      <Top q={q} setq={setq} ss={ss} countrysearch={countrysearch}  setcountrysearch={setcountrysearch}></Top>
      <div style={{ display: "flex", height: "100vh", width: "100vw" }}>
        <Left q={q} setcontinent={setcontinent}></Left>

        <Routes>
          <Route path="/error" element={<Error countrysearch={countrysearch}  setcountrysearch={setcountrysearch}></Error>}></Route>
          <Route path="/search" element={<Searchh countrysearch={countrysearch}  setcountrysearch={setcountrysearch}></Searchh>}></Route>
          <Route
            path="/continent"
            element={
              <Continent continent={continent} setss={setss}></Continent>
            }
          ></Route>

          <Route
            path="/"
            element={<Right ss={ss} setss={setss}></Right>}
          ></Route>
          <Route
            path="/Right"
            element={<Right ss={ss} setss={setss}></Right>}
          ></Route>
        </Routes>
      </div>
      <Bottom></Bottom>
    </div>
  );
}
